const OutcomeLabelMultiPosition = {
    title: 'Example JSON',
    expectedOutput: 'tricast',
    initialDisplayedCode: `{
    "outcomeId": 2950948551,
    "selections": {
        "1018896521_1028284759": "FIRST",
        "1018896521_1028278461": "SECOND",
        "1018896521_1028295999": "THIRD"
    },`,
    moreCode: `
    "betOffer": {
        "id": 2340032470,
        "betOfferType": {
            "id": 19,
            "name": "(1-3)"
        },
        "placeLimit": 3,
        "outcomes": [
            {
            "id": 3141005343,
            "label": "MultiPosition",
            "type": "OT_UNTYPED"
            }
        ],
        "place": true
    },
    "event": {
        "awayName": "EventAwayName",
        "homeName": "EventHomeName"
      }
}`,
};

export default OutcomeLabelMultiPosition;
